export default "__VITE_ASSET__xsmYPAXN__"